import jQuery from 'jquery';
// Resolved to the full jquery-ui/dist bundle via the `jquery-ui$` alias in
// webpack.config.js and jest.config.js (the package `main` is widget.js only
// since 1.12). This registers draggable/droppable/$.ui.mouse on jQuery before
// jquery-ui-touch-punch (below) patches $.ui.mouse for touch devices.
import 'jquery-ui';

declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}

// Touch-punch must load after globals exist (static import order + no ProvidePlugin in Jest).
type Root = typeof globalThis & { jQuery?: typeof jQuery; $?: typeof jQuery };
const root = globalThis as Root;
root.jQuery ??= jQuery;
root.$ ??= jQuery;

if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
  require('jquery-ui-touch-punch');
}

const { ui } = jQuery as typeof jQuery & { ui?: { touchPunch?: boolean } };
if (ui) ui.touchPunch = true;
